// src/config/gauges/fsc_unico.js
export const fscUnicoGaugeConfig = [
  // 1) Pres Succión C1
  {
    key: "presSuccionC1",
    title: "Pres. Succión Comp 1",
    unit: "psi",
    ranges: [
      { min: 110, max: 119.99, color: "green" },
      { min: 100, max: 109.99, color: "yellow" },
      { min: 120, max: 149.99, color: "yellow" },
      { min: 0,   max: 109.99, color: "red" },
      { min: 150, max: 10000, color: "red" },
    ],
  },

  // 2) Pres Succión C2
  {
    key: "presSuccionC2",
    title: "Pres. Succión Comp 2",
    unit: "psi",
    ranges: [
      { min: 110, max: 119.99, color: "green" },
      { min: 100, max: 109.99, color: "yellow" },
      { min: 120, max: 149.99, color: "yellow" },
      { min: 0,   max: 109.99, color: "red" },
      { min: 150, max: 10000, color: "red" },
    ],
  },

  // 3) Pres Descarga C1
  {
    key: "presDescargaC1",
    title: "Pres. Descarga Comp 1",
    unit: "psi",
    ranges: [
      { min: 420, max: 500.99, color: "green" },
      { min: 300, max: 419.99, color: "yellow" },
      { min: 500, max: 549.99, color: "yellow" },
      { min: 0,   max: 299.99, color: "red" },
      { min: 550, max: 10000, color: "red" },
    ],
  },

  // 4) Pres Descarga C2
  {
    key: "presDescargaC2",
    title: "Pres. Descarga Comp 2",
    unit: "psi",
    ranges: [
      { min: 420, max: 500.99, color: "green" },
      { min: 300, max: 419.99, color: "yellow" },
      { min: 500, max: 549.99, color: "yellow" },
      { min: 0,   max: 299.99, color: "red" },
      { min: 550, max: 10000, color: "red" },
    ],
  },

  // 5) Temp Evap Entrada
  {
    key: "tempEvapEnt",
    title: "Temp. Evap Entrada",
    unit: "°C",
    ranges: [
      { min: 7.1, max: 9, color: "green" },
      { min: 6.1, max: 7, color: "yellow" },
      { min: 9.1, max: 20, color: "yellow" },
      { min: -50, max: 6, color: "red" },
      { min: 20.1,  max: 200, color: "red" },
    ],
  },

  // 6) Temp Evap Salida
  {
    key: "tempEvapSal",
    title: "Temp. Evap Salida",
    unit: "°C",
    ranges: [
      { min: 7.1, max: 9, color: "green" },
      { min: 6.1, max: 7, color: "yellow" },
      { min: 9.1, max: 20, color: "yellow" },
      { min: -50, max: 6, color: "red" },
      { min: 20.1,  max: 200, color: "red" },
    ],
  },

  // 7) Superheat C1 
  {
    key: "superheatC1",
    title: "Superheat Comp 1",
    unit: "°F",
    ranges: [
      { min: 10, max: 19.99, color: "green" },
      { min: 5, max: 9.99, color: "yellow" },
      { min: 20, max: 24.99, color: "yellow" },
      { min: -50, max: 4.99, color: "red" },
      { min: 25,  max: 20000, color: "red" },
    ],
  },

  // 8) Superheat C2
  {
    key: "superheatC2",
    title: "Superheat Comp 2",
    unit: "°C",
    ranges: [
      { min: 10, max: 19.99, color: "green" },
      { min: 5, max: 9.99, color: "yellow" },
      { min: 20, max: 24.99, color: "yellow" },
      { min: -50, max: 4.99, color: "red" },
      { min: 25,  max: 20000, color: "red" },
    ],
  },

  // 9) Temp Succión C1
  {
    key: "tempSuccionC1",
    title: "Temp. Succión Comp 1",
    unit: "°C",
    ranges: [
      { min: 10, max: 14.99, color: "green" },
      { min: 6, max: 9.99, color: "yellow" },
      { min: 15, max: 19.99, color: "yellow" },
      { min: -50, max: 5.99, color: "red" },
      { min: 20,  max: 20000, color: "red" },
    ],
  },

  // 10) Temp Succión C2
  {
    key: "tempSuccionC2",
    title: "Temp. Succión Comp 2",
    unit: "°C",
    ranges: [
      { min: 10, max: 14.99, color: "green" },
      { min: 6, max: 9.99, color: "yellow" },
      { min: 15, max: 19.99, color: "yellow" },
      { min: -50, max: 5.99, color: "red" },
      { min: 20,  max: 20000, color: "red" },
    ],
  },
];
